import { AuthPage as AntdAuthPage, AuthProps } from "@pankod/refine-antd";
import { useRouterContext } from "@pankod/refine-core";

const authWrapperProps = {
  style: { background: `rgb(255 255 255)` },
};

const renderAuthContent = (content: React.ReactNode) => {
  const { Link } = useRouterContext();
  return (
    <div style={{ position: "relative" }}>
      <img
        src="/images/gradients/blue-blob.png"
        alt=""
        style={{
          pointerEvents: "none",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%) scale(100%)",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Main container - matching web-app's grid h-full max-w-md mx-auto */}
      <div
        style={{
          display: "grid",
          height: "100vh",
          maxWidth: "28rem",
          margin: "0 auto",
          textAlign: "center",
          placeItems: "center",
          paddingTop: "4rem",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div>
          {/* Logo container - matching web-app's w-20 */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "0.5rem",
              marginTop: "0.5rem",
              marginBottom: "1.5rem",
              alignItems: "middle",
            }}
          >
            <Link to="/">
              <img
                src="/images/logo.png?v=2"
                alt="Logo"
                style={{ objectFit: "contain", width: "80px" }}
              />
            </Link>
          </div>

          {/* Form container - matching web-app's flex flex-col gap-3 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              margin: "0 auto",
              marginTop: "1.5rem",
            }}
          >
            {/* Add auth-form-input class to style inputs */}
            <div className="auth-form-input">{content}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AuthPage: React.FC<AuthProps> = (props) => {
  return (
    <AntdAuthPage
      wrapperProps={authWrapperProps}
      renderContent={renderAuthContent}
      {...props}
    />
  );
};
